import LyG2Chart from './src/index.vue'

LyG2Chart.install = function (Vue) {
    Vue.component(LyG2Chart.name, LyG2Chart)
}

export default LyG2Chart



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/g2-chart/index.js
// module id = null
// module chunks = 